import { AxiosResponse } from "axios";
import API from "../api";

import { PriceGroup } from "../models/price.group";

const ROUTE_NAME = "price/group";

const PriceGroupService = {
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${ROUTE_NAME}/count`, { params: options });
  },
  async getById(id: number, options?: any): Promise<AxiosResponse<PriceGroup>> {
    return await API.get(`/${ROUTE_NAME}/${id}`, { params: options });
  },
  async getAll(options?: any): Promise<AxiosResponse<PriceGroup[]>> {
    return await API.get(`/${ROUTE_NAME}`, { params: options });
  },
  async create(priceGroup: PriceGroup): Promise<AxiosResponse<PriceGroup>> {
    return await API.post(`/${ROUTE_NAME}`, priceGroup);
  },
  async update(id: number, priceGroup: PriceGroup): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/${id}`, priceGroup);
  },
  async delete(id: number): Promise<AxiosResponse<PriceGroup>> {
    return await API.delete(`/${ROUTE_NAME}/${id}`);
  },
};

export default PriceGroupService;
